import { useBusinesses } from '../api/getBusinesses';
import { useBusinessesLogin } from '../api/getBusinessLogin';
import { Table, Spinner } from '@/components/Elements';
import { useAuth } from '@/lib/auth';
import Refresh from '@/assets/img/refresh-icon.png';
import { Business } from '@/features/business/types';
import { APP_PATH } from '@/config';
import storage from '@/utils/storage';
import { useNavigate } from 'react-router-dom';
import React, { ChangeEvent, useEffect, useState } from 'react';
import Lottie from 'lottie-react';
import progressAnimation from '@/assets/animation/save_loader.json';
import noDataAnimation from '@/assets/animation/no_data.json';
import '../../businesses/components/BusinessUpdate.scss';
import 'react-datepicker/dist/react-datepicker.css';
import { formatValue } from 'react-currency-input-field';
import RPayment from '@/assets/img/request_payment.png';
import LocationIcon from '@/assets/img/location.svg';
import MasterKey from '@/assets/img/master_key.png';
import PPayment from '@/assets/img/pending_payment.png';
import SPayment from '@/assets/img/success_payment.png';
import ReactPaginate from 'react-paginate';
import BusinessConfigDialog from '../components/BusinessConfigDialog';
import BusinessRegstrationUpdate from '../components/BusinessRegstrationUpdate';
import Utils from '@/utils/util';
import { Version, useAppVersion,useEditAppConfig } from '@/features/location/api/locationRequests';
export const MobileAppConfiguration = () => {
  const [totalPages, setTotalPages] = useState(0);
  const perPage = 10;
  const [selectedPage, setSelectedPage] = useState(1);
  const { user } = useAuth();
  const navigate = useNavigate();
  const useGetVersionMutation = useAppVersion();
  const useUpdateVersionMutation = useEditAppConfig();
  const useGetLoginPayoutsMutation = useBusinessesLogin();
  const [appCOnfig, setAppConfig] = useState<Version>();
  const [showPaymentDialog, setPaymentDialog] = useState(false);
  const [selectedBusiness, setSelectedBusiness] = useState<Business>();
  const [searchQuery, setSearchQuery] = useState<string>();
  const [showUpdateDialog, setUpdateDialog] = useState(false);


  useEffect(() => {
      getAppVersion();
      }, []);

      const getAppVersion = async()=>{
        const res = await useGetVersionMutation.mutateAsync({
        });

       // console.log("sssssssss",res)
        if(res && res.data){
            setAppConfig(res.data)
        }else{
          const resDefault = {
            title : 'App Update Required!',
            message : 'For more features and a better user experience, please update this app.',
            iosVersion : '0.0.1',
            androidVersion : '0.0.1',
            isForced : false,
          }
          setAppConfig(resDefault)
        }
      }


      const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
        if (appCOnfig) {
          const bizDt: Version = appCOnfig || ({} as Version);
    
          if (event.target.id === 'title') {
            bizDt.title = event.target.value;
          } else if (event.target.id === 'message') {
            bizDt.message = event.target.value;
          } else if (event.target.id === 'ios') {
            bizDt.iosVersion = event.target.value;
          } else if (event.target.id === 'android') {
            bizDt.androidVersion = event.target.value;
          }
          setAppConfig({ ...bizDt });
        }
      };
  return (
    <div>
        
      {appCOnfig && <div className={'page-title upcoming-title refresh-title margin-bottom-20'}>
        App Config
        <button
          onClick={async () => {
            getAppVersion();
          }}
          type="button"
          className="btn-style done-btn refresh-btn"
        >
          {useGetVersionMutation.isLoading ? (
            <Lottie className="progress-animation-sync" animationData={progressAnimation} />
          ) : (
            <img src={Refresh} className="refresh-icon" />
          )}
        </button>


        <div className="registration-label text-label">Title</div>

        <div className="mb-20-p pb-10">
            <input
              id="title"
              value={appCOnfig?.title}
              onChange={handleChange}
              type="text"
              className=" cust-input"
              placeholder="Title"
            />
          </div>


          <div className="registration-label text-label">Message</div>
          <div className="mb-20-p pb-10">
            <input
              id="message"
              value={appCOnfig?.message}
              onChange={handleChange}
              type="text"
              className=" cust-input"
              placeholder="Message"
            />
          </div>


          <div className="registration-label text-label">IOS Version</div>

          <div className="mb-20-p pb-10">
            <input
              id="ios"
              value={appCOnfig?.iosVersion}
              onChange={handleChange}
              type="text"
              className=" cust-input"
              placeholder="ios version"
            />
          </div>

          <div className="registration-label text-label">Android Version</div>
          <div className="mb-20-p pb-10">
            <input
              id="android"
              value={appCOnfig?.androidVersion}
              onChange={handleChange}
              type="text"
              className=" cust-input"
              placeholder="android version"
            />
          </div>

          <div className="mb-20-p pet-owner-registration app-row pb-10">
            <div className="registration-label  label-app">Force Update required</div>
            <div className="toggle-btn-container  label-app">
              <label className="switch">
                <input
                  type="checkbox"
                  checked={appCOnfig?.isForced}
                  onChange={(e) => {
                    if (appCOnfig) {
                      setAppConfig({ ...appCOnfig, isForced: e.target.checked })
                    }
                  }}
                  title={
                    appCOnfig?.isForced
                      ? 'True'
                      : 'False'
                  }
                />
                <span className="slider round"></span>
              </label>
            </div>
          </div>
      </div>}

      <div className="mb-20-p save-btn-outer">
            <button
              onClick={async () => {
                //console.log("asdada",appCOnfig)
                if(appCOnfig){
                  const response = await useUpdateVersionMutation.mutateAsync({ data: appCOnfig });
                  if(response) {
                    getAppVersion()
                  }
                }
                }
              }
              type="button"
              className="btn-style loading-btn-style"
            >
              <div className="loader-animation-btn">
                {useUpdateVersionMutation.isLoading ? (
                  <>
                    <Lottie className="progress-animation" animationData={progressAnimation} />
                    <span>Saving...</span>
                  </>
                ) : (
                  <span>Save</span>
                )}
              </div>
            </button>
          </div>
      </div>
  );
};
